"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  kr: "zh-TW",
  한국어: "중국어(번체)",
  "받은 알림이 없습니다": "暂无任何提示",
  알림: "提示",
  설정: "設定",
  "모두 읽음": "全部已讀",
  "읽은 알림 삭제": "刪除已讀短信",
  "모두 삭제": "刪除全部",
  "변경했던 모든 세부 설정값을 초기 상태로 되돌립니다.\n초기화한 알림 설정은 저장 시 적용됩니다.": "所有已變更的設定值都將初始化。\n初始化的提示設定會在保存後生效。",
  "알림 콘텐츠 설정": "提示內容設定",
  초기화: "初始化",
  저장: "保存",
  "받은 알림이 없습니다.": "沒有提示。",
  "설정이 저장되었습니다.": "保存成功。",
  "설정 저장을 실패했습니다.": "保存設定失敗。",
  "x 알림 x": "請在",
  "알림 설정": "提示設定",
  "에서 받고 싶은 알림을 선택하세요.": "中選擇同意接收的提示。",
  "안내": "提醒",
  "더보기": "查看更多",
  "<em onclick={{handleGoLogin}}>로그인</em>하시면<br />좋아하시는 BJ와 방송의<br />새로운 소식을 알려드립니다.": "<em onClick={{handleGoLogin}}>登入</em>後即可收到<br />您喜歡的BJ與直播<br />的最新消息。"
};